import Center from './Center';

// export types
export type { CenterProps } from './Center';

// export components
export { Center };
export default Center;
